// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import DashboardDateRangeController from "./dashboard_date_range_controller"
application.register("dashboard-date-range", DashboardDateRangeController)

import FacebookFeedController from "./facebook_feed_controller"
application.register("facebook-feed", FacebookFeedController)

import InlineNameEditController from "./inline_name_edit_controller"
application.register("inline-name-edit", InlineNameEditController)

import Portfolios__Links__CreateController from "./portfolios/links/create_controller"
application.register("portfolios--links--create", Portfolios__Links__CreateController)
